import { useState, useEffect } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import http from 'http'
import { withProfile } from 'context/Profile'
import TrackDetail from './Detail'
import TrackFilter from './Filter'

import parseSearchParams from 'fn/parseSearchParams'

import {
  FiMap,
  FiArrowLeft,
  FiChevronsLeft,
  FiChevronLeft,
  FiChevronsRight,
  FiChevronRight
} from 'react-icons/fi'

const Tracks = ( {
  withProfile: { user }
} ) => {
  const navigate = useNavigate()
  const [ searchParams, setSeachParams ] = useSearchParams()
  const [ selectedRoute, setSelectedRoute ] = useState()
  const [ data, setData ] = useState( {
    page: [],
    total: 0,
    __offset: 0,
    __limit: 10
  } )

  useEffect( () => {
    const no = parseSearchParams( searchParams )

    http( {
      method: 'GET',
      url: '/track',
      params: {
        __select: 'name',
        ...no
      }
    } )
      .then( response => {
        setData( response.data )
      } )

  }, [ searchParams ] )

  const back = () => {
    navigate( '/main' )
  }

  const next = () => {
    const offset = parseInt( data.__offset ) + parseInt( data.__limit )

    if ( offset < data.total ) {
      setSeachParams( ( searchParams ) => {
        searchParams.set( '__offset', offset )
        return searchParams
      } )
    }
  }

  const prev = () => {
    const offset = parseInt( data.__offset ) - parseInt( data.__limit )

    if ( offset >= 0 ) {
      setSeachParams( ( searchParams ) => {
        searchParams.set( '__offset', offset )
        return searchParams
      } )
    }
  }

  const first = () => {
    if ( parseInt( data.__offset ) === 0 )
      return

    setSeachParams( ( searchParams ) => {
      searchParams.set( '__offset', 0 )
      return searchParams
    } )
  }

  const last = () => {
    const rest = data.total % parseInt( data.__limit )
    let offset = 0

    if ( rest > 0 )
      offset = data.total - rest
    else
      offset = data.total - data.__limit

    if ( offset === parseInt( data.__offset ) )
      return

    setSeachParams( ( searchParams ) => {
      searchParams.set( '__offset', offset )
      return searchParams
    } )
  }

  const openRoute = ( route ) => {
    setSelectedRoute( () => route )
  }

  return <section className="scroll one hs">

    <div className="bar">
      <button
        onClick={ back }
      >
        <FiArrowLeft />
      </button>

      <h1>tracks</h1>

      <TrackFilter />

    </div>

    { data.page.length === 0 ? <>placeholder</> : <div className="scroll one hs">
      <div className="scroll one in-air-2x">
        <ul className="list-menu">
          { data.page.map( ( route, ix ) => <li
            key={ ix }
            className="list-item"
            onClick={ () => openRoute( route ) }
          >
            <span className="icon">
              <FiMap />
            </span>

            <span className="one text">
              { route.name }
            </span>
          </li> ) }

        </ul>
      </div>

      <div className="bar">
        <button
          onClick={ first }
        >
          <FiChevronsLeft />
        </button>

        <button
          onClick={ prev }
        >
          <FiChevronLeft />
        </button>

        <h1 className="ta-center">
          { parseInt( data.__offset ) + 1 }
          &nbsp;
          -
          &nbsp;
          { ( parseInt( data.__offset ) + parseInt( data.__limit ) ) < data.total ? parseInt( data.__offset ) + parseInt( data.__limit ) : data.total }
          &nbsp;
          /
          &nbsp;
          { data.total }
        </h1>

        <button
          onClick={ next }
        >
          <FiChevronRight />
        </button>

        <button
          onClick={ last }
        >
          <FiChevronsRight />
        </button>
      </div>
    </div> }

    { selectedRoute ? <TrackDetail
      { ...selectedRoute }
      close={ () => setSelectedRoute( () => null ) }
    /> : null }
  </section>
}

export default withProfile( Tracks )
